<div class="loading-overlay" [ngStyle]="{'position': position}">
    <div class="loading-container">
        <img src="../../../../assets/gifs/primary-load.gif" width="75px" height="75px">
    </div>
</div>
